export default function RedirectActionView() {
  const action = useSel(s => s.actions.entities[s.local.selectedActionId])
  const config = action.config || {}
  const brandHomepageUrl = window.ENV?.CLIENT_BRAND?.custom_homepage_url
  const customRedirectUrl = config?.redirectUrl

  const resolvedUrl = customRedirectUrl || brandHomepageUrl

  return <div className="box narrow">
    <h2 className='no-margin-top'>Redirect</h2>
    <div className='field'>
      {resolvedUrl
        ? <label className="bold">This step will redirect to: {resolvedUrl}</label>
        : <label className="bold error-text">No redirect URL set — please configure a homepage URL in brand settings or set a custom URL on this action</label>
      }
      <p className="no-margin-bottom">
        { customRedirectUrl && <span>This is the custom URL set on this redirect action</span> }
        { !customRedirectUrl && brandHomepageUrl && <span>This redirect uses the brand homepage URL from brand settings</span> }
      </p>
    </div>
  </div>
}
